export default __webpack_public_path__ + "static/media/clock.a885da38.svg";